<template>
  <el-card>
    <el-form-item>
      <el-button @click="printPreview" :loading="loading">预览</el-button>
      <el-button @click="print" :loading="loading">打印</el-button>
      <KfMessage ref="commitMessage"></KfMessage>
    </el-form-item>
    <el-form-item>
      <div id="divPrint">
        <img class="preview-img" :src="imageBase64" :style="'width:' + imageWidth + 'px; height:' + imageHeight + 'px;'"
             v-if="imageBase64.length > 0">
      </div>
    </el-form-item>
  </el-card>
</template>

<script>
export default {
  name: "BusGlassPrint",

  props: {
    parentData: {
      type: Object,
      default() {
        return {}
      }
    },
  },

  data() {
    return {
      imageBase64: '',
      imageHeight: 310,
      imageWidth: 820,
      loading: false,
      printDto: {},
    }
  },
  methods: {

    async printPreview() {
      this.loading = true;
      await this.$axios.post('bus/print/createReplenishGlassLabel', this.parentData).then(response => {
        this.loading = false;
        let res = response.data

        this.printDto = res.data;
        this.imageBase64 = res.data.imageBase64 || '';

        if (this.imageBase64.length > 0) {
          this.imageBase64 = "data:image/jpeg;base64," + this.imageBase64;
        }
      }, error => {
        this.loading = false;
        this.$refs.commitMessage.showError(`生成打印图像失败，${error.message}`);
      })
    },
    async print() {
      this.loading = true;
      let {data: res} = await this.$axios.post('bus/print/boLiRePrint',this.parentData);
      if (res.code !== 0) {
        this.loading = false;
        this.$message.error(res.message)
      }else {
        this.loading = false;
          this.imageBase64 = res.data.imageBase64 || '';
          if (this.imageBase64.length > 0) {
            this.imageBase64 = "data:image/jpeg;base64," + this.imageBase64;
          }
        this.$message.success('打印成功！')
      }
    },

    printDiv() {
      //打印div
      //打开一个新窗口newWindow
      var newWindow = window.open("打印窗口", "_blank");
      //要打印的div的内容
      var docStr = document.getElementById("divPrint").innerHTML;
      //打印内容写入newWindow文档
      newWindow.document.write(docStr);
      //关闭文档
      newWindow.document.close();

      //调用打印机
      setTimeout(() => {
        newWindow.print();
        newWindow.close();
      }, 50);

      return false;
    }
  },
}
</script>

<style scoped>
.preview-img {
  width: 822px;
  height: 312px;
  border: solid 1px #a1a1a1;
}
</style>
